// extracted by mini-css-extract-plugin
export default {"form":"ProfileSection_form__DjyYL","title":"ProfileSection_title__GlT+a"};